<app-header [offlineMode]="offlineMode"></app-header>

<div class="page-container">
  <div class="main-container">
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (offlineMode && legacyOfflineUiEnabled) {
  <footer>
    <app-offline-toolbar></app-offline-toolbar>
  </footer>
}

<ng-template #header>
  <a role="link" [routerLink]="homeUrl">{{ title }}</a>
</ng-template>
